import React from 'react'
import { Navigate } from 'react-router-dom'
import { AuthService, getTemplatePermissions } from 'utility'

export const RequireTemplateCreatePermission = ({
    children,
    redirectTo = '/app/templates',
}) => {
    const { canCreateTemplate } = getTemplatePermissions(AuthService.getUser())

    if (!canCreateTemplate) {
        return <Navigate to={redirectTo} replace />
    }

    return children
}
